import { registerGlobalError } from 'containers/App/app.saga';

export const ERROR_TYPE = 'GLOBAL_ERROR/UNCAUGHT_SAGA_ERROR';

export const sagaErrorHandler = (error, { sagaStack, store }) => {
  if (__SERVER__) {
    // If it's SSR we want to rethrow the error so that the `global-error-handler`
    // can deal with it and render the corresponding 500 page.
    throw error;
  }

  error.sagaStack = sagaStack;

  store.dispatch(registerGlobalError(error));
};
